import { User } from '@cliengo/mfe-utils/types';
import { Avatar, ButtonBase, ButtonProps } from '@mui/material';
import { forwardRef } from 'react';

interface TriggerButtonProps extends ButtonProps {
  user: User;
}

export const TriggerButton = forwardRef<HTMLButtonElement, TriggerButtonProps>(
  (props, ref) => {
    const { id, onClick, user, ...rest } = props;

    const { sx, ...restProps } = rest;

    return (
      <ButtonBase
        ref={ref}
        aria-describedby={id}
        onClick={onClick}
        sx={{
          borderRadius: '100%',
          ...sx,
        }}
        {...restProps}
      >
        <Avatar
          alt={user.name}
          src={user.imageUrl}
          sx={{ width: 40, height: 40 }}
        />
      </ButtonBase>
    );
  }
);

TriggerButton.displayName = 'TriggerButton';
